import React, { PureComponent } from 'react';
import ReceiptDetails from './ReceiptDetails';
import OrderDetails from './OrderDetails';

class OrderHistoryBody extends PureComponent {
  render() {
    const { order, group } = this.props;
    return (
      <div className="panel-body" id={`${group}`}>
        <ReceiptDetails order={order} />
        <OrderDetails orderDescription={order.description} />
      </div>
    );
  }
}

export default OrderHistoryBody;



// WEBPACK FOOTER //
// ./src/views/CustomerOrderHistory/components/OrderHistoryPanel/OrderHistoryBody/index.jsx